module.exports = __webpack_public_path__ + "img/dropbox.0157e812.png";